import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import Invoice from './pages/invoice/invoiceList';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const invoicePageRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/invoice',
    component: Invoice,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INVOICE.SEARCH_INVOICE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const invoiceRoutes = [
    //salesPersonRoute,
    invoicePageRoute
];